export const SWITCH_LIST_REQUEST_GET = 'SWITCH_LIST_REQUEST_GET';
export const SWITCH_LIST_GET_SUCCESS = 'SWITCH_LIST_GET_SUCCESS';
export const SWITCH_LIST_GET_FAIL = 'SWITCH_LIST_GET_FAIL';

export const SWITCH_REQUEST_ADD = 'AP_REQUEST_ADD';
export const SWITCH_ADD_SUCCESS = 'AP_ADD_SUCCESS';
export const SWITCH_ADD_FAIL = 'AP_ADD_FAIL';
export const SWITCH_ADD_SUCCESS_MSG = 'DEVICE_ADDED_SUCCESSFULLY';
export const SWITCH_BULK_ADD_SUCCESS_MSG =
	'BULK_DEVICE_UPLOAD_INITIATED_SUCCESSFULLY';
export const RESET_ADD_SWITCH = 'RESET_ADD_SWITCH';

export const SWITCH_REQUEST_DELETE = 'AP_REQUEST_DELETE';
export const SWITCH_DELETE_SUCCESS = 'AP_DELETE_SUCCESS';
export const SWITCH_DELETE_FAIL = 'AP_DELETE_FAIL';
export const SWITCH_DELETE_SUCCESS_MSG =
	'SWITCH_DELETION_INITIATED_SUCCESSFULLY';
export const RESET_DELETE_SWITCH = 'RESET_DELETE_SWITCH';

export const GLOBAL_VLAN_LIST_REQUEST_GET = 'GLOBAL_VLAN_REQUEST_GET';
export const GLOBAL_VLAN_LIST_GET_SUCCESS = 'GLOBAL_VLAN_GET_SUCCESS';
export const GLOBAL_VLAN_LIST_GET_FAIL = 'GLOBAL_VLAN_GET_FAIL';

export const GLOBAL_VLAN_REQUEST_CREATE = 'GLOBAL_VLAN_REQUEST_CREATE';
export const GLOBAL_VLAN_CREATE_SUCCESS = 'GLOBAL_VLAN_CREATE_SUCCESS';
export const GLOBAL_VLAN_CREATE_FAIL = 'GLOBAL_VLAN_CREATE_FAIL';

export const GLOBAL_VLAN_REQUEST_UPDATE = 'GLOBAL_VLAN_REQUEST_UPDATE';
export const GLOBAL_VLAN_UPDATE_SUCCESS = 'GLOBAL_VLAN_UPDATE_SUCCESS';
export const GLOBAL_VLAN_UPDATE_FAIL = 'GLOBAL_VLAN_UPDATE_FAIL';

export const GLOBAL_VLAN_REQUEST_DELETE = 'GLOBAL_VLAN_REQUEST_DELETE';
export const GLOBAL_VLAN_DELETE_SUCCESS = 'GLOBAL_VLAN_DELETE_SUCCESS';
export const GLOBAL_VLAN_DELETE_FAIL = 'GLOBAL_VLAN_DELETE_FAIL';
export const GLOBAL_VLAN_DELETE_ERROR_MESSAGE_FOR_LINKED_DEVICES = 'PROFILE_LINKED_TO_SWITCH'
export const RESET_GLOBAL_VLAN_DELETE = 'RESET_GLOBAL_VLAN_DELETE';
export const RESET_GLOBAL_VLAN_ADD = 'RESET_GLOBAL_VLAN_ADD';
export const RESET_GLOBAL_VLAN_UPDATE = 'RESET_GLOBAL_VLAN_UPDATE';

export const SWITCH_PORTS_GET = 'SWITCH_PORTS_GET';
export const SWITCH_PORTS_GET_SUCCESS = 'SWITCH_PORTS_GET_SUCCESS';
export const SWITCH_PORTS_GET_FAIL = 'SWITCH_PORTS_GET_FAIL';

export const SWITCH_PORTS_FOR_POE_GET = 'SWITCH_PORTS_FOR_POE_GET';
export const SWITCH_PORTS_FOR_POE_GET_SUCCESS = 'SWITCH_PORTS_FOR_POE_GET_SUCCESS';
export const SWITCH_PORTS_FOR_POE_GET_FAIL = 'SWITCH_PORTS_FOR_POE_GET_FAIL';

export const SWITCH_VLANS_GET = 'SWITCH_VLANS_GET';
export const SWITCH_VLANS_GET_SUCCESS = 'SWITCH_VLANS_GET_SUCCESS';
export const SWITCH_VLANS_GET_FAIL = 'SWITCH_VLANS_GET_FAIL';

export const SWITCH_PORTS_ACL_GET = 'SWITCH_PORTS_ACL_GET';
export const SWITCH_PORTS_ACL_GET_SUCCESS = 'SWITCH_PORTS_ACL_GET_SUCCESS';
export const SWITCH_PORTS_ACL_GET_FAIL = 'SWITCH_PORTS_ACL_GET_FAIL';

export const SWITCH_ACL_MAC_GET = 'SWITCH_ACL_MAC_GET';
export const SWITCH_ACL_MAC_GET_SUCCESS = 'SWITCH_ACL_MAC_GET_SUCCESS';
export const SWITCH_ACL_MAC_GET_FAIL = 'SWITCH_ACL_MAC_GET_FAIL';

export const SWITCH_ACL_IPV4_GET = 'SWITCH_ACL_IPV4_GET';
export const SWITCH_ACL_IPV4_GET_SUCCESS = 'SWITCH_ACL_IPV4_GET_SUCCESS';
export const SWITCH_ACL_IPV4_GET_FAIL = 'SWITCH_ACL_IPV4_GET_FAIL';

export const SWITCH_ACL_IPV6_GET = 'SWITCH_ACL_IPV6_GET';
export const SWITCH_ACL_IPV6_GET_SUCCESS = 'SWITCH_ACL_IPV6_GET_SUCCESS';
export const SWITCH_ACL_IPV6_GET_FAIL = 'SWITCH_ACL_IPV6_GET_FAIL';

export const SWITCH_PORTS_ACL_PATCH = 'SWITCH_PORTS_ACL_PATCH';
export const SWITCH_PORTS_ACL_PATCH_SUCCESS = 'SWITCH_PORTS_ACL_PATCH_SUCCESS';
export const SWITCH_PORTS_ACL_PATCH_FAIL = 'SWITCH_PORTS_ACL_PATCH_FAIL';

export const SWITCH_DETAILS_GET = 'SWITCH_DETAILS_GET';
export const SWITCH_DETAILS_GET_SUCCESS = 'SWITCH_DETAILS_GET_SUCCESS';
export const SWITCH_DETAILS_GET_FAIL = 'SWITCH_DETAILS_GET_FAIL';

export const SWITCH_PORT_REQUEST_UPDATE = 'SWITCH_PORT_REQUEST_UPDATE';
export const SWITCH_PORT_UPDATE_SUCCESS = 'SWITCH_PORT_UPDATE_SUCCESS';
export const SWITCH_PORT_UPDATE_FAIL = 'SWITCH_PORT_UPDATE_FAIL';
export const SWITCH_PORT_UPDATE_SUCCESS_MSG =
	'SWITCH_CONFIGURATION_UPDATED_SUCCESSFULLY';
export const RESET_UPDATE_PORT_CONFIGURATION =
	'RESET_UPDATE_PORT_CONFIGURATION';

export const SWITCH_ADD_TRIGGER = 'SWITCH_ADD_TRIGGER';
export const SHOW_SWITCH_MODAL = 'SHOW_SWITCH_MODAL';

export const SWITCH_MODEL_DISTRIBUTION_GRAPH_GET =
	'SWITCH_MODEL_DISTRIBUTION_GRAPH_GET';
export const SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_SUCCESS =
	'SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_SUCCESS';
export const SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_GET_FAIL =
	' SWITCH_MODEL_DISTRIBUTION_GRAPH_GET_GET_FAIL';

export const GET_SWITCH_ALARM_COUNT_SUCCESS = 'GET_SWITCH_ALARM_COUNT_SUCCESS';
export const GET_SWITCH_ALARM_COUNT_FAIL = 'GET_SWITCH_ALARM_COUNT_FAIL';

export const GET_STATIC_MAC_LIST = "GET_STATIC_MAC_LIST";
export const GET_STATIC_MAC_LIST_SUCCESS = "GET_STATIC_MAC_LIST_SUCCESS"
export const GET_STATIC_MAC_LIST_FAILURE = "GET_STATIC_MAC_LIST_FAILURE"

export const GET_LLDP_REMOTE_DEVICES_LIST = "GET_LLDP_REMOTE_DEVICES_LIST";
export const GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS = "GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS"
export const GET_LLDP_REMOTE_DEVICES_LIST_FAILURE = "GET_LLDP_REMOTE_DEVICES_LIST_FAILURE"

export const GET_SWITCH_ALARMS_LIST = "GET_SWITCH_ALARMS_LIST";
export const GET_SWITCH_ALARMS_LIST_SUCCESS = "GET_SWITCH_ALARMS_LIST_SUCCESS"
export const GET_SWITCH_ALARMS_LIST_FAILURE = "GET_SWITCH_ALARMS_LIST_FAILURE"

export const GET_PORT_STATICS_LIST = "GET_PORT_STATICS_LIST";
export const GET_PORT_STATICS_LIST_SUCCESS = "GET_PORT_STATICS_LIST_SUCCESS"
export const GET_PORT_STATICS_LIST_FAILURE = "GET_PORT_STATICS_LIST_FAILURE"

export const CLEAR_PORT_STATICS_LIST = "CLEAR_PORT_STATICS_LIST";
export const CLEAR_PORT_STATICS_LIST_SUCCESS = "CLEAR_PORT_STATICS_LIST_SUCCESS"
export const CLEAR_PORT_STATICS_LIST_FAILURE = "CLEAR_PORT_STATICS_LIST_FAILURE"
export const CLEAR_PORT_STATICS_SUCCESS_MESSAGE ="Cleared Successfully"
export const RESET_PORT_STATICS_CLEAR_STATE= "RESET_PORT_STATICS_CLEAR_STATE"

export const GET_POE_UTILISATION_LIST = "GET_POE_UTILISATION_LIST";
export const GET_POE_UTILISATION_LIST_SUCCESS = "GET_POE_UTILISATION_LIST_SUCCESS"
export const GET_POE_UTILISATION_LIST_FAILURE = "GET_POE_UTILISATION_LIST_FAILURE"

export const GET_PORT_CONFS_LIST = "GET_PORT_CONFS_LIST";
export const GET_PORT_CONFS_LIST_SUCCESS = "GET_PORT_CONFS_LIST_SUCCESS"
export const GET_PORT_CONFS_LIST_FAILURE = "GET_PORT_CONFS_LIST_FAILURE"

export const GET_CPU_UTILISATION_LIST = "GET_CPU_UTILISATION_LIST";
export const GET_CPU_UTILISATION_LIST_SUCCESS = "GET_CPU_UTILISATION_LIST_SUCCESS"
export const GET_CPU_UTILISATION_LIST_FAILURE = "GET_CPU_UTILISATION_LIST_FAILURE"

export const GET_SWITCH_TRAFFIC_LIST = "GET_SWITCH_TRAFFIC_LIST";
export const GET_SWITCH_TRAFFIC_LIST_SUCCESS = "GET_SWITCH_TRAFFIC_LIST_SUCCESS"
export const GET_SWITCH_TRAFFIC_LIST_FAILURE = "GET_SWITCH_TRAFFIC_LIST_FAILURE"

export const POST_MOVE_SWITCH = 'POST_MOVE_SWITCH';
export const POST_MOVE_SWITCH_FAIL = 'POST_MOVE_SWITCH_FAIL';
export const POST_MOVE_SWITCH_SUCCESS = 'POST_MOVE_SWITCH_SUCCESS';
export const POST_MOVE_SWITCH_SUCCESS_MSG = 'SWITCH_MOVE_DONE_SUCCESSFULLY';
export const RESET_MOVE_SWITCH = 'RESET_MOVE_SWITCH';

export const ADD_VLAN_SWITCH = "ADD_VLAN_SWITCH"
export const ADD_VLAN_SWITCH_SUCCESS = "ADD_VLAN_SWITCH_SUCCESS"
export const ADD_VLAN_SWITCH_FAILURE = "ADD_VLAN_SWITCH_FAILURE"

export const UPDATE_SWITCH_VLAN = "UPDATE_SWITCH_VLAN"
export const UPDATE_SWITCH_VLAN_SUCCESS = "UPDATE_SWITCH_VLAN_SUCCESS"
export const UPDATE_SWITCH_VLAN_FAILURE = "UPDATE_SWITCH_VLAN_FAILURE"

export const GET_NETWORK_INTERFACES_LIST = "GET_NETWORK_INTERFACES_LIST";
export const GET_NETWORK_INTERFACES_LIST_SUCCESS = "GET_NETWORK_INTERFACES_LIST_SUCCESS"
export const GET_NETWORK_INTERFACES_LIST_FAILURE = "GET_NETWORK_INTERFACES_LIST_FAILURE"

export const GET_NETWORK_ROUTES_LIST = "GET_NETWORK_ROUTES_LIST";
export const GET_NETWORK_ROUTES_LIST_SUCCESS = "GET_NETWORK_ROUTES_LIST_SUCCESS"
export const GET_NETWORK_ROUTES_LIST_FAILURE = "GET_NETWORK_ROUTES_LIST_FAILURE"

export const GET_NETWORK_NEIGHBOUR_CACHE_LIST = "GET_NETWORK_NEIGHBOUR_CACHE_LIST";
export const GET_NETWORK_NEIGHBOUR_CACHE_LIST_SUCCESS = "GET_NETWORK_NEIGHBOUR_CACHE_LIST_SUCCESS"
export const GET_NETWORK_NEIGHBOUR_CACHE_LIST_FAILURE = "GET_NETWORK_NEIGHBOUR_CACHE_LIST_FAILURE"

export const MOVE_DYNAMIC_MAC = 'MOVE_DYNAMIC_MAC';
export const MOVE_DYNAMIC_MAC_FAIL = 'MOVE_DYNAMIC_MAC_FAIL';
export const MOVE_DYNAMIC_MAC_SUCCESS = 'MOVE_DYNAMIC_MAC_SUCCESS';

export const DELETE_STATIC_MAC = 'DELETE_STATIC_MAC';
export const DELETE_STATIC_MAC_FAIL = 'DELETE_STATIC_MAC_FAIL';
export const DELETE_STATIC_MAC_SUCCESS = 'DELETE_STATIC_MAC_SUCCESS';

export const SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_REQUEST = 'GET_SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_REQUEST';
export const SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_SUCCESS = 'SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_SUCCESS';
export const SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_FAIL = 'SWITCH_TRAFFIC_PERFORMANCE_GRAPH_API_FAIL';

export const SWITCH_TEMPRATURE_GRAPH_API_REQUEST = 'SWITCH_TEMPRATURE_GRAPH_API_REQUEST';
export const SWITCH_TEMPRATURE_GRAPH_API_SUCCESS = 'SWITCH_TEMPRATURE_GRAPH_API_SUCCESS';
export const SWITCH_TEMPRATURE_GRAPH_API_FAIL = 'SWITCH_TEMPRATURE_GRAPH_API_FAIL';

export const MAC_AGING_TIME =  "MAC_AGING_TIME"
export const MAC_AGING_TIME_SUCCESS = "MAC_AGING_TIME_SUCCESS"
export const MAC_AGING_TIME_FAILURE = "MAC_AGING_TIME_FAILURE"

export const GET_MAC_AGING_TIME =  "GET_MAC_AGING_TIME"
export const GET_MAC_AGING_TIME_SUCCESS = "GET_MAC_AGING_TIME_SUCCESS"
export const GET_MAC_AGING_TIME_FAILURE = "GET_MAC_AGING_TIME_FAILURE"
export const SWITCH_DASH_DOWNLOAD = "SWITCH_DASH_DOWNLOAD"
export const SWITCH_DASH_DOWNLOAD_SUCCESS = "SWITCH_DASH_DOWNLOAD_SUCCESS"

export const REBOOT_SWITCH = 'REBOOT_SWITCH'
export const REBOOT_SWITCH_SUCCESS = 'REBOOT_SWITCH_SUCCESS'
export const REBOOT_SWITCH_FAILURE = 'REBOOT_SWITCH_FAILURE'

export const PARTITION_SWITCH = 'PARTITION_SWITCH'
export const PARTITION_SWITCH_SUCCESS = 'PARTITION_SWITCH_SUCCESS'
export const PARTITION_SWITCH_FAILURE = 'PARTITION_SWITCH_FAILURE'

export const MST_INSTANCE_ADD_SUCCESS_MESSAGE = 'MST Instance data sent successfully.'
export const MST_INSTANCE_EDIT_SUCCESS_MESSAGE = 'MST Instance data updated and sent successfully.'
export const MST_INSTANCE_DELETE_SUCCESS_MESSAGE = 'Specified MST Instance(s) and associated port data deleted successfully.'
export const STP_UPDATE_MESSAGE ='CONFIGURATION_UPDATED_INTIATED'